/**
 * Checks if view is loaded inside CloudHub window as an iframe (means it is loading PC's IAM).
 * @returns {boolean} - true, if it is loaded in CH frame.
 */
export function isRunningInsideCH() {
    try {
        // CloudHub container window will set name of the iframe containing NC UI to 'ch-<appName>'
        return window !== top && window.name.startsWith('ch-');
    } catch (e) {
        // If accessing window.top throws an exception, assume it's not running inside CloudHub
        return false;
    }
}

/**
 * Checks if view is loaded inside the NC IAM
 * @returns {boolean} - true, if it is loaded in NC IAM
 */
export function isRunningNCIAM() {
    try {
        return window !== top && window.name.startsWith('ch-nc_');
    } catch (e) {
        // If accessing window.top throws an exception, assume it's not running inside NC IAM
        return false;
    }
}

/**
 * Checks whether the deployment is NC onprem/cloud
 * @returns {boolean} true if the deployment type is NC on prem
 */
export const isNcOnPremDeployment = () => {
    const { cloudDeployment, product } = window.productConfig || {};
    return product === 'NC' && cloudDeployment === false;
};

/**
 * Checks whether the deployment is NC cloud
 * @returns {boolean} true if the deployment type is NC cloud
 */
export function isNcCloudDeployment() {
    const { cloudDeployment, product } = window.productConfig || {};
    return isRunningNCIAM() && product === 'NC' && cloudDeployment === true;
}

/**
 * Checks whether the deployment is NC
 * @returns {boolean} true if the deployment type is NC
 */
export function isNcDeployment() {
    const { product } = window.productConfig || {};
    return isRunningNCIAM() && product === 'NC';
}
